import AppNotificationsContext from './AppNotificationsContext'
import { useContext } from 'react'

const useAppNotifications = () => useContext(AppNotificationsContext)

export default useAppNotifications
